// extracted by mini-css-extract-plugin
module.exports = {"outline":"links-module--outline--2bG8l","mobile":"links-module--mobile--89jOs"};